import retryToUpdateStartDate from 'core/services/getPlansByProductId/retryToUpdateStartDate'
import getStmAndFixed from 'core/services/getPlansByProductId/getSTMandFixed' // cspell:disable-line
import getStmAndBtm from 'core/services/getPlansByProductId/getSTMandBTM' // cspell:disable-line
import setBTMEligibility from 'core/controllerPlans/setBTMEligibility'
import getSTM from 'core/services/getPlansByProductId/getSTM'
import curry from 'utils/functional/curry'
import isBTMDisabled from 'core/controllerPlansBTM/isBTMDisabled'

function getPlansHandler(state) {
  return state.BTMEligibility ? getStmAndBtm(state) : getSTM(state)
}

export function getSTMBTM(state) {
  return setBTMEligibility(state).then(getPlansHandler)
}

function getPlans(state) {
  const plansPromise = isBTMDisabled() ? getSTM(state) : getSTMBTM(state)

  return plansPromise.then(curry(retryToUpdateStartDate)(getPlansHandler))
}

function getPlansEnrollHandler(state) {
  return state.BTMEligibility && !isBTMDisabled()
    ? getStmAndBtm(state)
    : getStmAndFixed(state)
}

export function getPlansEnroll(state) {
  return setBTMEligibility(state)
    .then(getPlansEnrollHandler)
    .then(curry(retryToUpdateStartDate)(getPlansEnrollHandler))
}

export default getPlans
